// extracted by mini-css-extract-plugin
module.exports = {"outdatedBrowserBanner":"outdated-browser-banner__outdatedBrowserBanner--3NEsX","title":"outdated-browser-banner__title--1BGLp","text":"outdated-browser-banner__text--1ELDL"};